import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { orderBy } from 'lodash-es'

import { type AppViewProps } from '@/components/templates/AppView'
import { type Team } from '@/model/contexts/TeamsProvider.tsx'

import { teamCar } from './teamCar.ts'

export const useTeamSidePanelData = ({
  teams,
  teamSortBy,
  onlyShowTeamsThatCanDriveAManualCar,
}: {
  teams: ReadonlyArray<Team & { hidden: boolean }>
  teamSortBy: 'asc' | 'desc'
  onlyShowTeamsThatCanDriveAManualCar: boolean
}): AppViewProps['data']['sidepanel']['teams'] => {
  const intl = useIntl()
  return useMemo(() => {
    const availableSortedTeams = orderBy(
      teams.filter(({ isAvailable }) => isAvailable),
      'availableSince',
      teamSortBy
    )
    return availableSortedTeams.map((team) => ({
      id: team._id,
      hidden: team.hidden || (onlyShowTeamsThatCanDriveAManualCar && !team.vehicle.manual),
      since: team.availableSince,
      startingLocation: team.startingLocation,
      base: team.base && intl.formatMessage({ id: 'sidepanel.team.base' }, { base: team.base }),
      car: teamCar(team),
    }))
  }, [intl, teams, teamSortBy, onlyShowTeamsThatCanDriveAManualCar])
}
